/**
 * URL 경로에 fnk 쿼리 파라미터를 추가합니다.
 * fnk가 없거나 배열이면 원본 경로를 그대로 반환합니다.
 */
export function appendFnk(path: string, fnk?: string | string[]): string {
  if (!fnk || Array.isArray(fnk)) return path;
  return path.includes("?") ? `${path}&fnk=${fnk}` : `${path}?fnk=${fnk}`;
}
